<template>
  <div class="posts-highlight">
    <Article-Contacts v-if="itemStore.type === 'contacts'" v-for="(item, nr) in itemStore.getItems" :key="item.id" :item="item" :nr="nr"/>
    <Article v-else v-for="(item, nr) in itemStore.getItems" :key="item.id" :item="item" :nr="nr"/>
  </div>
</template>

<script lang="ts" setup>
import Article from "@/components/Article.vue";
import ArticleContacts from "@/components/Article-contacts.vue";
import {useItemStore} from "@/itemStore";

const itemStore = useItemStore();
</script>

